import type { Ref } from 'vue'
import { computed, unref } from 'vue'

import { asyncComputed } from '@vueuse/core'

import { getMeassurements } from '@/services/api/masterData'
import type { MeasurementType } from '@/types/api/Masterdata'
import type { Incident } from '@/types/Incident'

export default (incident: Ref<Incident> | Incident, meassurementName: string, measurementsData?: MeasurementType[]) => {
  const meassurements = measurementsData
    ? computed(() => measurementsData)
    : asyncComputed(async () => {
        return await getMeassurements()
      })

  const myMeassurement = computed(() => {
    if (meassurements.value) {
      return meassurements.value.find((m) => m.name === meassurementName)
    } else {
      return null
    }
  })

  const meassurementComputed = computed({
    get() {
      if (myMeassurement.value) {
        const unrefIncident = unref(incident)
        const msmnt = unrefIncident.measurements?.find((m) => m.measurementType.id === myMeassurement.value?.id)
        return msmnt?.value
      } else {
        return null
      }
    },
    set(value) {
      const unrefIncident = unref(incident)
      if (myMeassurement.value) {
        const msmnt = unrefIncident.measurements?.find((m) => m.measurementType.id === myMeassurement.value?.id)
        if (msmnt) {
          msmnt.value = value ?? ''
        } else {
          if (!unrefIncident.measurements) {
            unrefIncident.measurements = []
          }

          unrefIncident.measurements.push({
            measurementType: {
              id: myMeassurement.value.id,
              unit: myMeassurement.value.unit,
              name: myMeassurement.value.name
            },
            value: value ?? ''
          })
        }
      }
    }
  })

  return meassurementComputed
}
